import Cookies from "js-cookie";
import React, {useEffect, useState} from "react";
import {AxiosCustomGet} from "../../components/axios/AxiosCustom";
import Config from "../../components/axios/Config";
import SwalToast from "../../components/helpers/SwalToast";
import httpclient from "../../components/httpclient";
import Title from "../../components/common/Title/Title";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../components/helpers/IsEmpty";
import {Modal, Button, Input} from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../components/common/Table/CustomTable";
import {renderColumns} from "./constants";
import {TiUser} from "react-icons/ti";

const ListOutletDebitCard = () => {
    const [id, setId] = useState();
    const [reason, setReason] = useState();
    const [gadaiCode, setGadaiCode] = useState();
    const [reward, setReward] = useState();
    const [remainingAuction, setRemainingAuction] = useState();
    const [description, setDescription] = useState();
    const [bank, setBank] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [accountName, setAccountName] = useState();
    const [paymentProof, setPaymentProof] = useState();
    const [approvalProof, setApprovalProof] = useState();
    const [records, setRecords] = useState([]);
    const [totalRecord, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState();
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [modalAdd, setModalAdd] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [modalReject, setModalReject] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tablePagination, setTablePagination] = useState({});
    const [searchTimeout, setSearchTimeout] = useState(null);

    useEffect(() => {
        getData();
    }, []);

    const handleSubmit = (isDelete = false) => {
        setSubmitting(true);

        let data = {
            name: reason,
        };

        if (IsEmpty(id)) {
            let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal`;
            httpclient
                .POST(url, data)
                .then((response) => {
                    console.log(response);
                    SwalToast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    window.location.reload(false);
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response.data.error);
                        SwalToast.fire({
                            icon: "error",
                            title: error.response.data.error.message,
                        });
                    } else {
                        console.log(error);
                        SwalToast.fire({
                            icon: "error",
                            title: "Whoops, something went wrong",
                        });
                    }
                })
                .finally(() => {
                    setSubmitting(false);
                });
        } else {
            let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal/${id}`;
            if (isDelete === true) {
                httpclient
                    .DELETE(url)
                    .then((response) => {
                        SwalToast.fire({
                            icon: "success",
                            title: response.data.message,
                        });
                        window.location.reload(false);
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data.error);
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            console.log(error);
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            } else {
                httpclient
                    .PUT(url, data)
                    .then((response) => {
                        SwalToast.fire({
                            icon: "success",
                            title: response.data.message,
                        });
                        window.location.reload(false);
                    })
                    .catch((error) => {
                        if (error.response) {
                            console.log(error.response.data.error);
                            SwalToast.fire({
                                icon: "error",
                                title: error.response.data.error.message,
                            });
                        } else {
                            console.log(error);
                            SwalToast.fire({
                                icon: "error",
                                title: "Whoops, something went wrong",
                            });
                        }
                    })
                    .finally(() => {
                        setSubmitting(false);
                    });
            }
        }
    };

    const handleEdit = (record) => {
        setReason(record.name);
        setId(record.id);
        setModalEdit(true);
    };

    const handleReject = (record) => {
        setId(record.id);
        setModalReject(true);
    };

    const handleCloseModalAdd = () => {
        setModalAdd(false);
    };

    const handleCloseModalEdit = () => {
        setModalEdit(false);
        setId("");
    };

    const handleCloseModalReject = () => {
        setModalReject(false);
        setReason("");
        setId("");
    };

    const getData = () => {
        setLoading(true);
        let url = `${process.env.REACT_APP_BASE_API_URL}point-withdrawal?name=${search}&page=${page}&size=${pageSize}`;
        AxiosCustomGet(
            url,
            Config({
                Authorization: `Bearer ${Cookies.get("access_token")}`,
            }),
            (response) => {
                setLoading(false);
                console.log(response);

                setRecords(response.data.data.items);
            },
            (error) => {
                setLoading(false);
                if (error.response) {
                    SwalToast.fire({
                        icon: "error",
                        title: error.response.data,
                    });
                } else {
                    SwalToast.fire({
                        icon: "error",
                        title: "Whoops, something went wrong",
                    });
                }
            }
        );
    };

    const searchData = (name) => {
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        setSearch(name);
        setSearchTimeout(setTimeout(function() {
            getData();
        }, 700));
    }

    return (
        <>
            <div>
                <div className="px-3">
                    <div className="py-4 d-flex justify-content-between" style={{fontSize: "13px"}}>
                        <div className="">
                            <Title text={"Kartu Debit Outlet"}/>
                            <Breadcrumb current={"Kartu Debit Outlet"}/>
                        </div>
                        <div style={{
                            padding: 13,
                            border: "1px solid #DCDCDC",
                            borderRadius: 5,
                            height: 50,
                            width: 222,
                        }}>
                            <div style={{
                                fontSize: 18,
                                color: "#303030",
                            }}>
                                <TiUser style={{marginBottom: 5, fontSize: 24, color: "#D6D6D6"}}/>
                                <span style={{fontWeight: 700}}>{records.length}</span> Kartu Debit
                            </div>
                        </div>
                    </div>
                    <div className="d-flex pt-3">
                        <div className="">
                            <p className="m-0">Nama Kategori:</p>
                            <input
                                type="number"
                                className="form-control border-97A0AE"
                                placeholder="Nama Kategori"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>
                        <div className="ml-2">
                            <p className="m-0">No. Rekening:</p>
                            <input
                                type="text"
                                className="form-control border-97A0AE"
                                placeholder="No. Rekening"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>
                        <div className="ml-2">
                            <p className="m-0">Nama Rekening:</p>
                            <input
                                type="text"
                                className="form-control border-97A0AE"
                                placeholder="Nama Rekening"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>
                        <div className="ml-2">
                            <p className="m-0">Nama Bank:</p>
                            <input
                                type="text"
                                className="form-control border-97A0AE"
                                placeholder="Nama Bank"
                                onChange={(e) => searchData(e.target.value)}
                            />
                        </div>

                        <div className="ml-auto" onClick={() => setModalAdd(true)}>
                            <button className="btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                                + Tambah Transaksi
                            </button>
                        </div>
                    </div>
                    <div style={{marginTop: 24}}>
                        <CustomTable
                            columns={renderColumns(handleEdit, handleReject)}
                            data={records}
                            loading={loading}
                            // handleTableChange={handleTableChange}
                            pagination={tablePagination}
                        />
                    </div>
                </div>
            </div>

            <Modal
                className="modal-add"
                centered
                title={`Tambah Transaksi`}
                visible={modalAdd}
                onOk={handleSubmit}
                onCancel={handleCloseModalAdd}
                footer={[
                    <Button
                        onClick={handleCloseModalAdd}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        disabled={submitting}
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#fff",
                            background: "#2C465C",
                        }}
                    >
                        Tambah
                    </Button>,
                ]}
            >
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Kode Gadai :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Kode Gadai"
                            value={gadaiCode}
                            onChange={(e) => setGadaiCode(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Reward :</div>
                    </div>
                    <div className="d-flex align-items-center" style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="number"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Reward"
                            value={reward}
                            onChange={(e) => setReward(e.target.value)}
                        />
                        <div className="color-A6A6A6 ml-1">Rupiah</div>
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Sisa Lelang :</div>
                    </div>
                    <div className="d-flex align-items-center" style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="number"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Sisa Lelang"
                            value={remainingAuction}
                            onChange={(e) => setRemainingAuction(e.target.value)}
                        />
                        <div className="color-A6A6A6 ml-1">Rupiah</div>
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Keterangan :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input.TextArea
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Keterangan"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Bank :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Bank"
                            value={bank}
                            onChange={(e) => setBank(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">No. Rekening :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="No. Rekening"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div className="color-A6A6A6">Nama Rekening :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Nama Rekening"
                            value={accountName}
                            onChange={(e) => setAccountName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div style={{color: "#A6A6A6"}}>Bukti Transfer :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="file"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Tambah File"
                            onChange={(e) => setPaymentProof(e)}
                        />
                        <p className="m-0 small">Format JPG/JPEG/PNG/PDF (Maks. 1MB)</p>
                    </div>
                </div>
                <div className="d-flex align-items-center mt-2">
                    <div style={{flex: 1}}>
                        <div style={{color: "#A6A6A6"}}>Bukti Persetujuan :</div>
                    </div>
                    <div style={{flex: 2}}>
                        <Input
                            style={{height: 36}}
                            required
                            type="file"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Tambah File"
                            onChange={(e) => setApprovalProof(e)}
                        />
                        <p className="m-0 small">Format JPG/JPEG/PNG/PDF (Maks. 1MB)</p>
                    </div>
                </div>
            </Modal>

            <Modal
                className="modal-edit"
                centered
                title={`Terima Pembayaran`}
                visible={modalEdit}
                onOk={handleSubmit}
                onCancel={handleCloseModalEdit}
                footer={[
                    <Button
                        onClick={handleCloseModalEdit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        disabled={submitting}
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#fff",
                            background: "#2C465C",
                        }}
                    >
                        Simpan
                    </Button>,
                ]}
            >
                <p className="m-0 small color-A6A6A6">Anda yakin telah menerima pembayaran ini?</p>
            </Modal>

            <Modal
                className="modal-reject"
                centered
                title={"Batalkan Pencairan Poin"}
                visible={modalReject}
                onOk={handleSubmit}
                onCancel={handleCloseModalReject}
                footer={[
                    <Button
                        onClick={handleCloseModalReject}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#000",
                            background: "#FFFFFF",
                        }}
                    >
                        Kembali
                    </Button>,
                    <Button
                        type="submit"
                        disabled={submitting}
                        onClick={handleSubmit}
                        style={{
                            border: "0.75px solid #DCDCDC",
                            borderRadius: 6,
                            width: 120,
                            height: 36,
                            color: "#fff",
                            background: "#EB2424",
                        }}
                    >
                        Tolak
                    </Button>,
                ]}
            >
                <div className="mt-2">
                    <div className="color-A6A6A6">Alasan :</div>
                    <div className="mt-1">
                        <Input.TextArea
                            style={{height: 36}}
                            required
                            type="text"
                            className="form-control border-DCDCDC text-input"
                            placeholder="Bukti transfer tidak valid"
                            onChange={(e) => setReason(e)}
                        />
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ListOutletDebitCard;